"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var MoreTableData = function MoreTableData(_ref) {
  var record = _ref.record;
  return /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 11,
    className: "m-1"
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    style: {
      height: "auto"
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Date Of Birth",
    text: "center",
    span: 2
  }, record.DOB)))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Mother_name",
    text: "center",
    span: 2
  }, record.Mother_name)))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Joining Date",
    text: "center",
    span: 2
  }, record.Joining_date)))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "School Type",
    span: 2
  }, record.School_type)))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "School Fee",
    span: 2
  }, record.School_fee ? record.School_fee : "No Fee Entered")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: " Class",
    text: "center",
    span: 2
  }, record.Class)))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Contact Number",
    text: "center",
    span: 2
  }, record.Calling_no)))))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12,
    className: "m-1"
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    style: {
      height: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "English Label",
    span: 2
  }, record.English_label ? record.English_label : "Null")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "English Worksheet No",
    span: 2
  }, record.English_worksheet_no ? record.English_worksheet_no : "Null")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Maths Worksheet No",
    span: 2
  }, record.Worksheet_no)))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Maths Label",
    span: 2
  }, record.Label)))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Address",
    span: 2
  }, record.Address)))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Maths Mode Status",
    span: 2
  }, record.Mode_status)))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "English Mode Status",
    span: 2
  }, record.English_mode_status)))))));
};

var _default = MoreTableData;
exports.default = _default;